import React from 'react';

const ElegantBackground = ({ children, className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Base background with cream to purple gradient */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDFBF7] via-[#F2E6FF] to-[#E5CCFF]">
          {/* Subtle shimmer effect */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-50 via-purple-50 to-yellow-50 animate-shimmer" />
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute inset-0">
          {/* Top curved line */}
          <div className="absolute top-0 left-0 w-full h-24 overflow-hidden">
            <svg className="absolute w-full h-24 text-purple-200/30" viewBox="0 0 1200 100" preserveAspectRatio="none">
              <path d="M0,50 C400,80 800,20 1200,50" fill="none" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>

          {/* Subtle grid for texture */}
          <div className="absolute inset-0" 
               style={{
                 backgroundImage: `
                   linear-gradient(to right, rgba(147, 51, 234, 0.03) 1px, transparent 1px),
                   linear-gradient(to bottom, rgba(147, 51, 234, 0.03) 1px, transparent 1px)
                 `,
                 backgroundSize: '50px 50px'
               }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

// Add the animations
const style = document.createElement('style');
style.textContent = `
  @keyframes shimmer {
    0%, 100% { transform: translateX(0); opacity: 0.2; }
    50% { transform: translateX(-50%); opacity: 0.3; }
  }

  .animate-shimmer {
    animation: shimmer 10s infinite linear;
  }
`;
document.head.appendChild(style);

export default ElegantBackground;